define.alias("shared/components/shared/button/copy", "settings/components/shared/button/copy");